










import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { Notify, Dialog } from 'vant';
@Component({})
export default class QrCodeZhpjFeedBack extends Vue {
  // classSolution: any = {};
  // waitClassSolutions: any = [];
  // async mounted() {
  //   let openSolutionId: any = this.$route.query.openSolutionId;
  //   if (openSolutionId) {
  //     {
  //       //获取当前学员所有待评综合
  //       const { data } = await api.ComperhensiveEvaluation.getMyWaitEvaluate_GET();
  //       this.waitClassSolutions = data;
  //     }
  //     let waitOpenSolutionIds = this.waitClassSolutions.map((item: any) => {
  //       return item.openClassSolutionId;
  //     });
  //     //判断当前扫码评价的综合机构是否在待评列表中
  //     if (waitOpenSolutionIds.indexOf(openSolutionId) >= 0) {
  //       //获取当前培训班信息
  //       const { data } = await api.ClassSolution.findOneById_GET({ id: openSolutionId });
  //       this.classSolution = data!;
  //       let endClassDate = new Date(this.classSolution.endClassDate);
  //       let dateTimeNow = new Date();
  //       let comprehensiveObject: any = {};
  //       let classItem = this.classSolution;
  //       comprehensiveObject.className = classItem.className;
  //       comprehensiveObject.createdOn = classItem.createdOn;
  //       comprehensiveObject.deptId = classItem.deptId;
  //       comprehensiveObject.deptName = classItem.deptName;
  //       comprehensiveObject.endClassDate = classItem.endClassDate;
  //       comprehensiveObject.endSignUpDate = classItem.endSignUpDate;
  //       comprehensiveObject.locationCategory = classItem.locationCategory;
  //       comprehensiveObject.openClassSolutionId = classItem.id;
  //       comprehensiveObject.runClassType = classItem.runClssType;
  //       comprehensiveObject.startClassDate = classItem.startClassDate;
  //       comprehensiveObject.startSignUpDate = classItem.startSignUpDate;
  //       comprehensiveObject.trainType = classItem.trainType;
  //       comprehensiveObject.trainingAgencyId = classItem.trainingAgencyId;
  //       comprehensiveObject.trainingAgencyName = classItem.trainingAgencyName;
  //       if (endClassDate < dateTimeNow) {
  //         this.$router.push({
  //           name: "feedback",
  //           params: {
  //             feedbackTitle: "综合评价",
  //             comprehensiveDetail: comprehensiveObject,
  //           },
  //         });
  //       } else {
  //         this.$nextTick(() => {
  //           Dialog.confirm({
  //             message: "当前培训班培训还未结束，不能评价！",
  //           });
  //           setTimeout(() => {
  //             Dialog.close();
  //             this.$router.push({
  //               name: "myFeedbacks",
  //               params: { feedbackStatus: "待评综合" },
  //             });
  //           }, 3000);
  //         });
  //       }
  //     } else {
  //       this.$nextTick(() => {
  //         Dialog.confirm({
  //           message: "您未报名当前培训班或者已经评价过，故不能评价！",
  //         });
  //         setTimeout(() => {
  //           Dialog.close();
  //           this.$router.push({
  //             name: "myFeedbacks",
  //             params: { feedbackStatus: "待评综合" },
  //           });
  //         }, 3000);
  //       });
  //     }
  //   }
  // }
}
